<template>
  <div
    class="modal fade createNewModal"
    id="AddModeleBoiteModal"
    tabindex="-1"
    aria-hidden="true"
    ref="addModeleBoiteModalRef"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="modeleBoiteForm" @submit="addModeleBoite" :validation-schema="modeleBoiteSchema">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Code <span class="text-danger">*</span>
                </label>
                <Field name="code" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le code"/>
                <ErrorMessage name="code" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Libellé <span class="text-danger">*</span>
                </label>
                <Field name="libelle" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libellé"/>
                <ErrorMessage name="libelle" class="text-danger"/>
              </div>
            </div>
            <button
              class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
              type="submit"
            >
            {{ btntext }}
            </button>
          </div>
        </Form>
        </div>
        <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="resetValue()"
        ></button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted, ref, toRef, watch } from 'vue';
import { Form, Field, ErrorMessage, useForm } from 'vee-validate';
import * as Yup from 'yup';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import { hideModal, showModal, success, error } from '@/utils/utils';
import { ModeleBoite } from '@/models/ModeleBoite';

export default {
  name: "AddModeleBoiteModal",
  components: {
    Form,
    Field,
    ErrorMessage
  },
  props: {
    item: {
      type: Number,
      required: true,
    }
  },
  setup(props, { emit }){

    const modeleBoiteSchema = Yup.object().shape({
      libelle: Yup.string().required('Le libellé est obligatoire'),
      code: Yup.string().required('Le code est obligatoire').max(5, "Vous ne devez pas dépasser cinq caractères"),
    });

    let modeleBoiteForm = ref<ModeleBoite | null>(null);
    const router = useRouter();
    const addModeleBoiteModalRef = ref<null | HTMLElement>(null);
    const isUPDATE = ref(false);
    const title = ref('Ajouter un modèle de boite');
    const btntext = ref('Ajouter');

    watch(() => props.item , (newValue) => {
      if(newValue != 0){
        getModeleBoite(newValue);
        isUPDATE.value = true;
        btnTitle();
      }
    });

    const btnTitle = async () => {
      if (isUPDATE.value) {
         title.value = "Modifier un modèle de boite";
         btntext.value = "Modifier";
      }else{
         title.value = "Ajouter un modèle de boite";
         btntext.value = "Ajouter";
      }
    }

    const getModeleBoite = async (id: number) => {
      return ApiService.get("/modele_boites/"+id)
      .then(({ data }) => {
        
        for (const key in data.data) {
          modeleBoiteForm.value?.setFieldValue(key, data.data[key]);
        }
        emit('openmodal', addModeleBoiteModalRef.value);

      })
      .catch(({ response }) => {
        error(response.data.msg)
      });
    }

    const addModeleBoite = async (values: any ,modeleBoiteForm) => {
     
      values = values as ModeleBoite;
      if(isUPDATE.value){
        ApiService.put("/modele_boites/"+values.id,values)
        .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              modeleBoiteForm.resetForm();
              hideModal(addModeleBoiteModalRef.value);
              btnTitle();
              emit('close');
            }
        })

        .catch(({ response }) => {
            error(response.data.message);
        });
      }else{
        ApiService.post("/modele_boites",values)
        .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message);

              modeleBoiteForm.resetForm();
              hideModal(addModeleBoiteModalRef.value);
              emit('close');
            }
        })
        .catch(({ response }) => {
            error(response.data.message);
        });
      }
      
    };

    
    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isUPDATE.value=false;
        formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };
    return { modeleBoiteSchema, addModeleBoite, modeleBoiteForm, addModeleBoiteModalRef, title, btntext, resetValue };
  },
};
</script>